import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DistributeJustifiedH } from '../icons';
import { ToolbarButton } from '../ui';
import { getAlignToContainer, getSelectedObjectsIDs } from '../editor';
import { getCurrentPiece, distributeObjectsJustifiedH } from '../project';

const ButtonDistributeJustifiedH = ({ disabled, onClick }) => {
  if (disabled) {
    return null;
  }

  return <ToolbarButton icon={<DistributeJustifiedH />} onClick={onClick} />;
};

ButtonDistributeJustifiedH.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const reduxConnector = connect(
  state => {
    let container = getCurrentPiece(state);
    if (!getAlignToContainer(state)) {
      container = null;
    }

    const ids = getSelectedObjectsIDs(state);
    let disabled = true;
    if (ids.size >= 2) {
      disabled = false;
    }
    return { ids, disabled, container };
  },
  { distributeObjectsJustifiedH },
  ({ ids, container, ...state }, actions) => ({
    ...state,
    onClick: () => actions.distributeObjectsJustifiedH({ ids, container }),
  }),
);

export default reduxConnector(ButtonDistributeJustifiedH);
